import React from "react";
import "./ihreVorteile.scss";
export default function IhreVorteile() {
  return (
    <div>
      <div className="ihre-voreile-all-contnet-alignment">
        <div className="text-grid">
          <div className="text-grid-items">
            <div className="divider"></div>
          </div>
          <div className="text-grid-items">
            <h2
              className="animate__backInUp animate__animated wow"
              data-wow-offset="100"
            >
              Ihre Vorteile:
            </h2>
          </div>
        </div>
        <div className="grid">
          <div className="grid-items">
            <ul>
              <li
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                Bei Personalengpässen schaffen Sie sich Freiräume.
              </li>
              <li
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                Sie müssen keine Angestellten zum Vermieten einsetzen. Kosten
                entstehen Ihnen nur bei Erfolg.
              </li>
              <li
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                Wir sind für Sie da! Mit all unserer Erfahrung stehen wir Ihnen
                fair und korrekt zur Seite.
              </li>
            </ul>
          </div>
          <div className="grid-items">
            <ul>
              <li
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                Ob Sie bundesweit oder regional operieren, Sie sparen Personal-,
                Raum-, Telekommunikations-, Material-, Fahrzeugkosten
              </li>
              <li
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                Wir erarbeiten Ihnen gerne ein individuelles Angebot.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
